import { rest } from "msw";
import { setServerTime } from "../responseResolvers/serverTime";
import { baseUrl } from "./constants";

export const glideServerTimeHandlers = [
    /******************* Glide Server Time **********************/
    rest.get(`${baseUrl}/serverTime`, setServerTime),
];
